import React from 'react';
import { useNavigate } from 'react-router-dom';
import { GlobeIcon, ArrowRightIcon } from 'lucide-react';
interface ExemptionCheckCardProps {
  className?: string;
}
const ExemptionCheckCard: React.FC<ExemptionCheckCardProps> = ({
  className = ''
}) => {
  const navigate = useNavigate();
  const handleCheckExemption = () => {
    navigate('/student/exemptions/new');
  };
  const handleViewGreenlist = () => {
    navigate('/student/greenlist');
  };
  return <div className={`bg-white rounded-lg border border-gray-100 shadow-sm overflow-hidden hover:shadow-md transition-all ${className}`} aria-label="Check if you need a study exemption" data-id="element-115">
      <div className="p-5" data-id="element-116">
        <div className="flex flex-col md:flex-row md:items-center" data-id="element-117">
          {/* Icon Section - Left on desktop, top on mobile */}
          <div className="flex-shrink-0 mb-4 md:mb-0 md:mr-6" data-id="element-118">
            <div className="w-14 h-14 rounded-full bg-primary-50 flex items-center justify-center" data-id="element-119">
              <GlobeIcon className="w-8 h-8 text-primary-500" data-id="element-120" />
            </div>
          </div>
          {/* Content Section - Center */}
          <div className="flex-grow md:mr-6" data-id="element-121">
            <h3 className="text-lg font-medium text-gray-800 mb-1" data-id="element-122">
              Planning to study abroad?
            </h3>
            <p className="text-sm text-gray-600 mb-4 md:mb-0" data-id="element-123">
              Some universities and programs require an official exemption from
              the Ministry of Higher Education. Check your eligibility in
              minutes.
            </p>
          </div>
          {/* CTA Section - Right on desktop, bottom on mobile */}
          <div className="flex-shrink-0 flex flex-col items-start md:items-end" data-id="element-124">
            <button onClick={handleCheckExemption} className="h-10 px-4 bg-primary-500 text-white rounded-lg text-sm font-medium hover:bg-primary-600 transition-colors flex items-center" data-id="element-125">
              Check If I Need an Exemption
              <ArrowRightIcon className="w-4 h-4 ml-2" data-id="element-126" />
            </button>
            <button onClick={handleViewGreenlist} className="mt-2 text-sm text-primary-600 hover:text-primary-700 hover:underline flex items-center" data-id="element-127">
              View Greenlisted Universities
              <ArrowRightIcon className="w-3 h-3 ml-1" data-id="element-128" />
            </button>
          </div>
        </div>
      </div>
    </div>;
};
export default ExemptionCheckCard;